<template>
     <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-7">
                    <button
                        class="btn btn-secondary"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                        type="button"
                        @click="showBody(0)"
                        aria-expanded="false"
                    >
                        Lista
                    </button>
                    <button
                        class="btn btn-secondary"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                        type="button"
                        @click="showCreate(1)"
                        aria-expanded="false"
                    >
                        Crear
                    </button>
                    <button
                        class="btn btn-secondary"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                        type="button"
                        @click="showBody(3)"
                        aria-expanded="false"
                    >
                        Ordenar & Seleccionar
                    </button>
                </div>
                <div class="col-md-5 text-right align-top text-success">
                    <span style="font-size: 20px">Configuración Preguntas</span>
                </div>

                <config-question-component-list
                    v-if="page == 0"
                    v-bind:model_id="model_id"
                    @change="callChangeList"
                ></config-question-component-list>
                <config-question-component-edit
                    v-if="page == 1"
                    v-bind:parent_id="model_id"
                    v-bind:model_id="contest_question_criteria_id"
                    @change="callChangeCreate"
                    :key="componentKey"
                ></config-question-component-edit>
                <config-question-component-edit
                    v-if="page == 2"
                    v-bind:parent_id="model_id"
                    v-bind:model_id="contest_question_criteria_id"
                ></config-question-component-edit>
                <config-question-component-order
                    v-if="page == 3"
                    v-bind:model_id="model_id"
                ></config-question-component-order>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            model_name: "",
            page: 0,
            contest_question_criteria_id: 0,
            componentKey: 0,
            pass: null,
        };
    },
    methods: {
        showBody(vallue) {
            this.page = vallue;
            this.contest_question_criteria_id = 0;
        },
        showCreate() {
            this.contest_question_criteria_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        callChangeList(id) {
            this.contest_question_criteria_id = id;
            this.page = 2;
        },
        callChangeCreate() {
            this.page = 0;
        },
    }
};
</script>
